import { render, staticRenderFns } from "./AttributeGroup.vue?vue&type=template&id=4dd626a4&"
import script from "./AttributeGroup.vue?vue&type=script&lang=js&"
export * from "./AttributeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports